/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Criteria for winning a sponsored competition
 * @export
 */
export const WinningCriteria = {
    TOP_GUILD_XP_GAINER: 'TOP_GUILD_XP_GAINER',
    TOP_OVERALL_XP_GAINER: 'TOP_OVERALL_XP_GAINER',
    WINNING_GUILD: 'WINNING_GUILD'
} as const;
export type WinningCriteria = typeof WinningCriteria[keyof typeof WinningCriteria];


export function instanceOfWinningCriteria(value: any): boolean {
    for (const key in WinningCriteria) {
        if (Object.prototype.hasOwnProperty.call(WinningCriteria, key)) {
            if (WinningCriteria[key as keyof typeof WinningCriteria] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WinningCriteriaFromJSON(json: any): WinningCriteria {
    return WinningCriteriaFromJSONTyped(json, false);
}

export function WinningCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WinningCriteria {
    return json as WinningCriteria;
}

export function WinningCriteriaToJSON(value?: WinningCriteria | null): any {
    return value as any;
}

export function WinningCriteriaToJSONTyped(value: any, ignoreDiscriminator: boolean): WinningCriteria {
    return value as WinningCriteria;
}

